"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _CompletedContext = require("../CompletedContext");

var _MusicEditor = _interopRequireDefault(require("./MusicEditor"));

var TaskMusicViewer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskMusicViewer, _React$Component);

  var _super = (0, _createSuper2.default)(TaskMusicViewer);

  function TaskMusicViewer(props) {
    var _this$props$musicConf;

    var _this;

    (0, _classCallCheck2.default)(this, TaskMusicViewer);
    _this = _super.call(this, props);
    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = true;
      _this.state.showAnswer = false;
      _this.state.notation = _this.props.notation || _this.props.musicInitial || _this.props.notation_initial;
    }

    _this.state.completed = true;
    _this.state.precursor = ((_this$props$musicConf = _this.props.musicConfiguration) === null || _this$props$musicConf === void 0 ? void 0 : _this$props$musicConf.split(';').join('\n')) + '\n';
    _this.musiceditor = /*#__PURE__*/_react.default.createRef();
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TaskMusicViewer, [{
    key: "arraysAreIdentical",
    value: function arraysAreIdentical(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      for (var i = 0, len = arr1.length; i < len; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      var _this$props$musicConf2;

      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }

      if (prevprops.musicInitial !== this.props.musicInitial) {
        this.state.notation = this.props.notation || this.props.musicInitial || this.props.notation_initial || "zzzzzzzz";
      }

      this.state.precursor = ((_this$props$musicConf2 = this.props.musicConfiguration) === null || _this$props$musicConf2 === void 0 ? void 0 : _this$props$musicConf2.split(';').join('\n')) + '\n';
    }
  }, {
    key: "onChange",
    value: function onChange(newNotation) {
      this.setState({
        notation: newNotation
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$zoom, _this$props$rawAbc;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task task-scale-builder"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "scale-builder-container",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement(_MusicEditor.default, Object.assign({
        ref: this.musiceditor
      }, this.props, this.state, {
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper,
        addClasses: true,
        addHotspots: !this.state.completed,
        monophonic: true,
        accidentals: true,
        millisecondsPerMeasure: this.props.musicDuration,
        zoom: (_this$props$zoom = this.props.zoom) !== null && _this$props$zoom !== void 0 ? _this$props$zoom : 2,
        precursor: this.props.rawAbc ? '' : this.state.precursor,
        notation: (_this$props$rawAbc = this.props.rawAbc) !== null && _this$props$rawAbc !== void 0 ? _this$props$rawAbc : this.state.notation,
        onChange: this.onChange,
        completed: this.state.completed
      }))));
    }
  }]);
  return TaskMusicViewer;
}(_react.default.Component);

exports.default = TaskMusicViewer;
TaskMusicViewer.contextType = _CompletedContext.CompletedContext;